"use strict";
import { __require as t } from "./index.es325.js";
var r, e;
function u() {
  if (e) return r;
  e = 1;
  var a = Function.prototype.call, n = Object.prototype.hasOwnProperty, o = t();
  return r = o.call(a, n), r;
}
export {
  u as __require
};
//# sourceMappingURL=index.es326.js.map
